import { lazyRoute } from '../lib/lazyRoute';

/**
 * Every route below the sign-in wall loads on demand.
 *
 * The bundle these routes pull in — the PDF stack, xlsx, the charting library —
 * is around 2.6MB that a signed-out visitor previously downloaded before the
 * login form could paint. The three public pages stay statically imported: they
 * are the first thing an unauthenticated visitor sees, and making them async
 * would only trade bytes for a round trip.
 */
export const NotificationPage = lazyRoute(
  'NotificationPage',
  () => import('../components/NotificationPage'),
);
export const ARInvoicesLandingPage = lazyRoute(
  'ARInvoicesLandingPage',
  () => import('../features/ar-invoices'),
);
export const CreateInvoicePage = lazyRoute(
  'CreateInvoicePage',
  () => import('../components/invoices/CreateInvoicePage'),
);
export const AccountPage = lazyRoute('AccountPage', () => import('../pages/AccountPage'));
export const AdminAccountingPage = lazyRoute(
  'AdminAccountingPage',
  () => import('../pages/AdminAccountingPage'),
);
export const AdminAgentSurfacePage = lazyRoute(
  'AdminAgentSurfacePage',
  () => import('../pages/AdminAgentSurfacePage'),
);
export const AdminLlmCallsPage = lazyRoute(
  'AdminLlmCallsPage',
  () => import('../pages/AdminLlmCallsPage'),
);
export const AdminNotificationsPage = lazyRoute(
  'AdminNotificationsPage',
  () => import('../pages/AdminNotificationsPage'),
);
export const AdminPaymentsPage = lazyRoute(
  'AdminPaymentsPage',
  () => import('../pages/AdminPaymentsPage'),
);
export const AdminPipelinesPage = lazyRoute(
  'AdminPipelinesPage',
  () => import('../pages/AdminPipelinesPage'),
);
export const AdminRfpTemplatesPage = lazyRoute(
  'AdminRfpTemplatesPage',
  () => import('../pages/AdminRfpTemplatesPage'),
);
export const AdminTasksPage = lazyRoute('AdminTasksPage', () => import('../pages/AdminTasksPage'));
export const ChartLinesPage = lazyRoute(
  'ChartLinesPage',
  () => import('../features/chart-of-accounts/pages/ChartLinesPage'),
);
export const AssociationsPage = lazyRoute(
  'AssociationsPage',
  () => import('../pages/AssociationsPage'),
);
export const BoardPackagePage = lazyRoute(
  'BoardPackagePage',
  () => import('../pages/BoardPackagePage'),
);
export const BudgetPage = lazyRoute('BudgetPage', () => import('../pages/BudgetPage'));
export const ExpensesPage = lazyRoute('ExpensesPage', () => import('../pages/ExpensesPage'));
export const LoansPage = lazyRoute('LoansPage', () => import('../features/loans'));
export const CalendarPage = lazyRoute('CalendarPage', () => import('../pages/CalendarPage'));
export const ComparisonDetailPage = lazyRoute(
  'ComparisonDetailPage',
  () => import('../pages/ComparisonDetailPage'),
);
export const ContractDetailPage = lazyRoute(
  'ContractDetailPage',
  () => import('../pages/ContractDetailPage'),
);
export const ContractsPage = lazyRoute('ContractsPage', () => import('../pages/ContractsPage'));
export const CreateRfpPage = lazyRoute('CreateRfpPage', () => import('../pages/CreateRfpPage'));
export const DashboardPage = lazyRoute('DashboardPage', () => import('../pages/DashboardPage'));
export const DocumentDetailPage = lazyRoute(
  'DocumentDetailPage',
  () => import('../pages/DocumentDetailPage'),
);
export const DocumentsPage = lazyRoute('DocumentsPage', () => import('../pages/DocumentsPage'));
export const ExceptionQueuePage = lazyRoute(
  'ExceptionQueuePage',
  () => import('../pages/ExceptionQueuePage'),
);
export const IncomeScheduler = lazyRoute(
  'IncomeScheduler',
  () => import('../pages/IncomeScheduler'),
);
export const InvoiceDetailPage = lazyRoute(
  'InvoiceDetailPage',
  () => import('../pages/InvoiceDetailPage'),
);
export const InvoicesPage = lazyRoute('InvoicesPage', () => import('../pages/InvoicesPage'));
export const OwnershipsPage = lazyRoute('OwnershipsPage', () => import('../pages/OwnershipsPage'));
export const PaymentsExamplePage = lazyRoute(
  'PaymentsExamplePage',
  () => import('../pages/PaymentsExamplePage'),
);
export const PropertiesPage = lazyRoute('PropertiesPage', () => import('../pages/PropertiesPage'));
export const IncomeCommitmentsPage = lazyRoute(
  'IncomeCommitmentsPage',
  () => import('../features/commitments/pages/IncomeCommitmentsPage'),
);
export const IncomeChargeMappingPage = lazyRoute(
  'IncomeChargeMappingPage',
  () => import('../features/chart-of-accounts/pages/IncomeChargeMappingPage'),
);
export const BudgetPlanningPage = lazyRoute(
  'BudgetPlanningPage',
  () => import('../features/budget-planning/pages/BudgetPlanningPage'),
);
export const RentRadarPage = lazyRoute(
  'RentRadarPage',
  () => import('../features/rent-radar/pages/RentRadarPage'),
);
export const RentRadarPropertiesPage = lazyRoute(
  'RentRadarPropertiesPage',
  () => import('../features/rent-radar/pages/RentRadarPropertiesPage'),
);
export const OnboardingPage = lazyRoute(
  'OnboardingPage',
  () => import('../features/onboarding/pages/OnboardingPage'),
);
export const OrganizationPage = lazyRoute(
  'OrganizationPage',
  () => import('../features/onboarding/pages/OrganizationPage'),
);
export const ProposalDetailPage = lazyRoute(
  'ProposalDetailPage',
  () => import('../pages/ProposalDetailPage'),
);
export const RfpDetailPage = lazyRoute('RfpDetailPage', () => import('../pages/RfpDetailPage'));
export const UploadPage = lazyRoute('UploadPage', () => import('../pages/UploadPage'));
export const UsersPage = lazyRoute('UsersPage', () => import('../pages/UsersPage'));
export const PlaygroundPage = lazyRoute(
  'PlaygroundPage',
  () => import('../pages/playground/PlaygroundPage'),
);
